import script from "./Unsubscribe.vue?vue&type=script&setup=true&lang=ts"
export * from "./Unsubscribe.vue?vue&type=script&setup=true&lang=ts"

import "./Unsubscribe.vue?vue&type=style&index=0&id=bb7e8462&lang=scss"

const __exports__ = script;

export default __exports__